var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("scout-tab-panel", {
    attrs: {
      "is-active": _vm.isActive,
      title: "本日のおすすめ",
      name: "pickup",
      link: _vm.link,
      tooltip: "アクティブで応募につながり易い会員を自動抽出します。",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }